import React, { useEffect, useState, useRef } from 'react';
import { Camera } from 'lucide-react';
import './Gallery.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const Gallery = () => {
  const [photos, setPhotos] = useState([]);
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const res = await fetch(`${API_URL}/api/photos`);
        const data = await res.json();
        setPhotos(data.photos || []);
      } catch (err) {
        console.error('Error loading photos:', err);
      }
    };
    fetchPhotos();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="gallery" id="galeria" ref={ref} data-testid="gallery-section">
      <div className="gallery-container">
        <div className={`gallery-header ${visible ? 'vis' : ''}`}>
          <div className="section-fire-line" />
          <span className="gallery-eyebrow"><Camera size={14} /> Galería</span>
          <h2 className="gallery-title">Momentos con Sabor</h2>
        </div>
        <div className={`gallery-grid ${visible ? 'vis' : ''}`} data-testid="gallery-grid">
          {photos.map((photo, i) => (
            <div
              className={`gallery-item ${i === 0 ? 'gallery-item-large' : ''}`}
              key={i}
              style={{ animationDelay: `${i * 0.2}s` }}
              data-testid={`gallery-photo-${i}`}
            >
              <img src={photo.url} alt={photo.title} loading="lazy" />
              <div className="gallery-item-overlay">
                <strong>{photo.title}</strong>
                {photo.description && <span>{photo.description}</span>}
              </div>
              <div className="gallery-item-border" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
